import React from "react";
import { useSelector } from "react-redux";
import HmsHotelOnboardingWizard from "./HMSHotelWizard/HmsHotelOnboardingWizard";
import IhclHotelOnboardingWizard from "./IhclHotelWizard/IhclHotelOnboardingWizard";

const HotelOnboardingWizard = () => {
  const { viewType } = useSelector((state) => state.viewTypeReducer);
  const { chainId } = useSelector((state) => state.chainIdReducer);

  return (
    <div className="wizard-wrapper">
      {viewType === "custom" && <HmsHotelOnboardingWizard selectedHotelDetails={chainId}/>}
      {viewType === "hotelApp" && <IhclHotelOnboardingWizard selectedHotelDetails={chainId} viewType={viewType}/>}
    </div>
  );
};

export default HotelOnboardingWizard;
